var __jsx = React.createElement;
/**
 * Represents ThreeColumnTextBlock Component.
 * @author Harmeet
 */import React from 'react';
import cn from 'classnames';
import styled from 'styled-components';
import styles from './ThreeColumnText.style';
import RichText from '../../atoms/RichText/RichText';
import Heading from '../../atoms/Heading';
import Para from '../../atoms/Para';
import urlSlug from 'url-slug';
import Anchor from '../../atoms/Anchor';
var ThreeColumnTextBlock = styled.section.withConfig({
  componentId: "sc-1suc4ci-0"
})(["", ";"], styles);
var ThreeColumnText = function ThreeColumnText(_ref) {
  var _ctasCollection$items;
  var threeColumnTextData = _ref.threeColumnTextData;
  if (!threeColumnTextData) {
    return null;
  }
  var heading = threeColumnTextData.heading,
    categoryTitle = threeColumnTextData.categoryTitle,
    description = threeColumnTextData.description,
    anchorLink = threeColumnTextData.anchorLink,
    textBlocksCollection = threeColumnTextData.textBlocksCollection,
    ctasCollection = threeColumnTextData.ctasCollection,
    alignment = threeColumnTextData.alignment,
    topPadding = threeColumnTextData.topPadding,
    bottomPadding = threeColumnTextData.bottomPadding;
  var className = "organism row threeColumnText";

  // top padding from contentful
  className += topPadding === null || topPadding === 'Default' || topPadding === undefined ? '' : " padding-top-override-".concat(topPadding.toLowerCase());

  // bottom padding from contentful
  className += bottomPadding === null || bottomPadding === 'Default' || bottomPadding === undefined ? '' : " padding-bottom-override-".concat(bottomPadding.toLowerCase());
  var textBlocksArray = textBlocksCollection && textBlocksCollection.items;
  if (!textBlocksArray) {
    textBlocksArray = threeColumnTextData.textBlocks;
  }
  var idVal = anchorLink ? urlSlug(anchorLink) : '';
  return __jsx(ThreeColumnTextBlock, {
    styleType: "threeColumnTextBlock",
    props: threeColumnTextData,
    className: cn('nva-3-column', alignment === 'Center' ? 'nva-3-column--center' : 'nva-3-column--left', className),
    id: idVal
  }, __jsx("div", {
    className: "nva-3-column__container container"
  }, __jsx("div", {
    className: "nva-3-column__top-wrapper block block0 col-xs-12"
  }, categoryTitle && __jsx(Para, {
    className: "nva-3-column__category-title u-overline"
  }, categoryTitle), __jsx(Heading, {
    HeadingType: "h2",
    className: "nva-3-column__heading"
  }, heading), description && __jsx(RichText, {
    className: "nva-3-column__description",
    jsonContent: description.json ? description.json : description
  })), __jsx("div", {
    className: "nva-3-column__row row"
  }, textBlocksArray && textBlocksArray.map(function (block, i) {
    var _block$body, _block$body$links, _block$body$links$ent, _block$body2, _block$body2$links, _block$body2$links$en, _block$body3, _block$body3$links, _block$body3$links$as;
    var content = block.body && block.body.json;
    if (!content) {
      content = block.body && block.body.body;
    }
    return __jsx("div", {
      key: i,
      className: "nva-3-column__column"
    }, __jsx(RichText, {
      jsonContent: content,
      entriesContent: (_block$body = block.body) === null || _block$body === void 0 ? void 0 : (_block$body$links = _block$body.links) === null || _block$body$links === void 0 ? void 0 : (_block$body$links$ent = _block$body$links.entries) === null || _block$body$links$ent === void 0 ? void 0 : _block$body$links$ent.block,
      linksContent: (_block$body2 = block.body) === null || _block$body2 === void 0 ? void 0 : (_block$body2$links = _block$body2.links) === null || _block$body2$links === void 0 ? void 0 : (_block$body2$links$en = _block$body2$links.entries) === null || _block$body2$links$en === void 0 ? void 0 : _block$body2$links$en.inline,
      richTextEmbeddedAsset: (_block$body3 = block.body) === null || _block$body3 === void 0 ? void 0 : (_block$body3$links = _block$body3.links) === null || _block$body3$links === void 0 ? void 0 : (_block$body3$links$as = _block$body3$links.assets) === null || _block$body3$links$as === void 0 ? void 0 : _block$body3$links$as.block
    }));
  })), __jsx("div", {
    className: "nva-3-column__ctas-wrapper"
  }, ctasCollection === null || ctasCollection === void 0 ? void 0 : (_ctasCollection$items = ctasCollection.items) === null || _ctasCollection$items === void 0 ? void 0 : _ctasCollection$items.map(function (cta, i) {
    return __jsx(Anchor, {
      key: i,
      className: "nva-3-column__cta",
      href: cta.url,
      target: cta.target,
      rel: cta.rel,
      title: cta.title,
      styleType: i > 0 ? 'secondary-anchor' : 'primary-anchor'
    }, cta.label);
  }))));
};
export default ThreeColumnText;